module.exports = __webpack_public_path__ + "img/icon-comment.010d1f29.svg";